import { PieceType } from "./PieceType";
import { Position } from "./Position";

export class Piece {
  public positions: Position[] = new Array<Position>();
  constructor(
    public position: Position,
    public pieceType: PieceType,
    public isMain: boolean,
  ) {
    this.positions.push(position);
    switch (pieceType) {
      case PieceType.UNIT:
        break;
      case PieceType.LARGE:
        this.positions.push(new Position(position.x + 1, position.y));
        break;
      case PieceType.LONG:
        this.positions.push(new Position(position.x, position.y + 1));
        break;
      case PieceType.SQUARE:
        this.positions.push(new Position(position.x, position.y + 1));
        this.positions.push(new Position(position.x + 1, position.y));
        this.positions.push(new Position(position.x + 1, position.y + 1));
        break;
    }
  }

  public move(deltaX: number, deltaY: number): void {
    // no need to move  this.position, because it is already in this.positions
    this.positions.forEach((p) => {
      p.x += deltaX;
      p.y += deltaY;
    });
  }

  public isAt(x: number, y: number): boolean {
    return this.positions.some((p) => p.x === x && p.y === y);
  }

  public isAtExact(x: number, y: number): boolean {
    return this.position.x === x && this.position.y === y;
  }

  public clone(): Piece {
    return new Piece(this.position.clone(), this.pieceType, this.isMain);
  }
}
